<template>
  <b-card no-body style="border: none; height: 100%; margin: 0;">
    <b-table no-provider-paging responsive id="my-table" :items="tableData"
             :per-page="perPage"
             :current-page="currentPage"
             tbody-tr-class="test"
             :fields="fields" v-on:row-clicked="rowClicked"
             v-on:row-contextmenu="onRightClicked"
             :sort-by="sortBy"
             :sort-desc="sortDesc"
             sort-icon-left
             class="custom-auto-height">
      <template #table-colgroup="scope">
        <col
            v-for="field in scope.fields"
            :key="field.key"
            :style="{ width: calcSize(field.key) }"
        />
      </template>
      <template v-slot:cell(ziel_datum)="data">
        <div v-if="isOlder(data.item.ziel_datum)" style="color: red"><b>{{data.value}}</b></div>
        <div v-else>{{data.value}}</div>
      </template>
      <template v-slot:cell(auf_stat)="data">
        <overdue-icon
            v-if="getZielStatus(data.item.ziel_datum) === 'overdue'"
            title=""
            v-tooltip="'Überfällig'"
            class="icon-1_5x" fillColor="#383838" style="color: red" :size="72" ></overdue-icon>
        <circle-day-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'today'"
            title=""
            v-tooltip="'Heute'"
            class="icon-1_5x" fillColor="#383838" style="color: red" :size="72" ></circle-day-icon>
        <circle-week-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'week'"
            title=""
            v-tooltip="'Eine Woche'"
            class="icon-1_5x" fillColor="#383838" style="color: orange" :size="72" ></circle-week-icon>
        <circle-month-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'month'"
            title=""
            v-tooltip="'Ein Monat'"
            class="icon-1_5x" fillColor="#383838" style="color: green" :size="72" ></circle-month-icon>
        <circle-half-year-icon
            v-else-if="getZielStatus(data.item.ziel_datum) === 'halfYear'"
            title=""
            v-tooltip="'Ein halbes Jahr'"
            class="icon-1_5x" fillColor="#383838" style="color: #008080" :size="72" ></circle-half-year-icon>
        <circle-year-icon
            v-else
            title=""
            v-tooltip="'Ein Jahr'"
            class="icon-1_5x" fillColor="#383838" style="color: #004680" :size="72" ></circle-year-icon>
      </template>
      <template v-slot:cell(fertig_datum)="data">
        <checkmark
            v-if="data.item.fertig_datum !== null"
            title=""
            v-tooltip="'Fertig gestellt'"
            class="icon-1_5x icon-def-green" fillColor="#383838" :size="72" ></checkmark>
        <span v-if="data.item.fertig_datum !== null" :style="data.item.count_finished === data.item.count_open + data.item.count_finished ? 'padding-top: 3px; margin-left: 3px; color: green;' : 'padding-top: 3px; margin-left: 3px'"><b>{{dateToString(data.item.fertig_datum)}}</b></span>

        <div v-if="data.item.fertig_datum === null"></div>
      </template>
      <template v-slot:cell(completed)="data">
        <div style="display: flex;
    flex-direction: row;" v-if="data.item.count_open > 0 || data.item.count_finished > 0" >
          <span :style="data.item.count_finished === data.item.count_open + data.item.count_finished ? 'padding-top: 3px; margin-left: 3px; color: green;' : 'padding-top: 3px; margin-left: 3px'"><b>{{data.item.count_finished}}/{{data.item.count_open + data.item.count_finished}}</b></span>
        </div>
        <div v-else>

        </div>
      </template>
    </b-table>
    <div class="mt-3 custom-flex-0">
      <b-pagination v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"

                    aria-controls="my-table" align="center"></b-pagination>
    </div>
    <vue-context ref="menu">
      <li
          v-for="opt in currentOptions"
          :key="opt"
      >
        <a href="#" @click.prevent="onOptionClicked(opt)">{{opt}}</a>
      </li>
    </vue-context>
  </b-card>
</template>

<script>
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import CheckBoldIcon from 'vue-material-design-icons/CheckBold.vue';
import CurrencyEurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import CloseCircleIcon from 'vue-material-design-icons/CloseCircle';
import CircleYearIcon from 'vue-material-design-icons/CircleOutline.vue'
import CircleHalfYearIcon from 'vue-material-design-icons/CircleSlice2.vue'
import CircleMonthIcon from 'vue-material-design-icons/CircleSlice4.vue'
import CircleWeekIcon from 'vue-material-design-icons/CircleSlice6.vue'
import CircleDayIcon from 'vue-material-design-icons/CircleSlice7.vue'
import OverdueIcon from 'vue-material-design-icons/BellCircleOutline.vue'
import {Server_URL, Server_URL_MAENGELMELDER} from "../../shared/utils";
import {decryptAES, decryptFile} from "../../shared/crypto";
import HasAttachment from 'vue-material-design-icons/Attachment.vue';
import Checkmark from 'vue-material-design-icons/Check.vue';
import Alert from 'vue-material-design-icons/AlertCircleOutline.vue';
import MapIcon from 'vue-material-design-icons/Map.vue';
import VueContext from 'vue-context';




export default {
  name: 'PlanningListTable',
  components: {
    BookOpenPageVariantIcon, CheckBoldIcon, CurrencyEurIcon, CloseCircleIcon,
    HasAttachment, Checkmark, Alert, MapIcon, VueContext,
    CircleYearIcon, CircleHalfYearIcon, CircleMonthIcon, CircleWeekIcon, CircleDayIcon, OverdueIcon
  },
  props:{
    tableData: {
      type: Array,
      default: () => []
    },
    rowClickCallback: {
      type: Function,
      default: undefined
    },
  },
  data: () => {
    return {
      sortBy: 'ziel_datum',
      sortDesc: false,
      fields: [
        {key: 'gi_auf_ext', label: "Listenname", sortable: true},
        {key: 'datum', label: "Anlage", formatter: "dateToString", sortable: true},
        {key: 'ziel_datum', label: "Ziel", formatter: "dateToString", sortable: true},
        {key: 'auf_stat', label: ""},
        {key: 'fertig_datum', label: 'Fertiggestellt'},
        {key: 'completed', label: 'Teilaufgaben'},
        {key: 'sachbearbeiter', label: 'Anlage von', formatter: (value, key, item) => {
            if (item === null) {
              return null;
            }
            let res = JSON.parse(sessionStorage.getItem(item.sachbearbeiter));
            if (res === null) {
              return value;
            }
            return res.first_name + " " + res.surname;
          }, sortable: true, sortByFormatted: true},

      ],
      currentPage: 1,
      perPage: 20,
      url: Server_URL,
      urlMm: Server_URL_MAENGELMELDER,
      currentClicked: null,
    }
  },
  computed: {
    rows() {
      return this.tableData.length
    },
    currentOptions() {
      if (!this.currentClicked) {
        return [];
      } else {
        let res = [];
        res.push("Details");
        if (this.currentClicked.fertig_datum === null) {
          res.push("Fertigstellen");
        }
        return res;
      }
    }
  },
  methods: {
    calcSize(field) {
      if (field === 'selected') {
        return '36px';
      } else {
        return 'initial';
      }
    },
    rowClicked(item, index, target) {
      this.$router.push("/auftraege/auftrag/"+item.id);

      if (this.rowClickCallback !== undefined) {
        this.rowClickCallback(item, index);
      }
    },
    onRightClicked(item, index, target) {
      target.preventDefault();
      this.currentClicked = item;
      this.$refs.menu.open(target);
    },
    onOptionClicked(option) {
      switch (option) {
        case "Details":
          this.$router.push("/auftraege/auftrag/"+this.currentClicked.id);
          break;
        case "Fertigstellen":
          this.$emit("finish-task", this.currentClicked)
          break;
      }
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    isOlder(value) {
      let valueDate = new Date(value.replace('Z',''));
      valueDate.setHours(0, 0, 0, 0)
      let cur = new Date();
      cur.setHours(0, 0, 0, 0)
      return valueDate.getTime() < cur.getTime();
    },
    getZielStatus(ziel) {
      const now = new Date();
      now.setHours(0, 0, 0, 0)
      const dueDate = new Date(ziel.replace('Z',''));
      dueDate.setHours(0, 0, 0, 0)
      const timeDifference = dueDate - now;
      const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

      if (daysDifference < 0) {
        return "overdue";
      } else if (daysDifference === 0) {
        return "today";
      } else if (daysDifference <= 7) {
        return "week";
      } else if (daysDifference <= 30) {
        return "month";
      } else if (daysDifference <= 182) {
        return "halfYear";
      } else  {
        return "year";
      }
    },
    formateTeilaufgaben(value, key, item) {
      if (item === null) {
        return null;
      }
      let ges = item.number_open + item.number_finished;
      if (ges === 0) {
        return "keine";
      } else {
        return ""+ item.number_finished + "/" + ges;
      }
    },
    responseError(response) {
      console.log(response)
    },
  }
}
</script>

<style scoped>


.h-1px {
  height: 1px;
}

.icon-def-grey {
  color: #5f6368;
}

.icon-def-green {
  color: green;
}

::v-deep .table td {
  padding: 0.15rem 0.75rem !important;
}

::v-deep table.b-table > tbody > tr.b-table-details > td {
  border-top: none !important;
  padding: 0px !important;
}

::v-deep .table.b-table>thead>tr>th[aria-sort]:before {
  float: none !important;
  margin-left: 0 !important;
  margin-right: 0.5em !important;
  font-size: larger;
}

::v-deep .table thead th {
  white-space: nowrap;
}

</style>

